import React, { useState } from 'react';

import { useProcurement } from './context/ProcurementContext';
import { SWITCH_CONTRACT_MANAGEMENT_TAB_EVENT } from './face/contract-management/contractDashboardHelpers';
import ProcurementContractManagementDashboardTab from './procurement-contract-management-tab/ProcurementContractManagementDashboardTab';
import ProcurementContractManagementExpenditureContractsTab from './procurement-contract-management-tab/ProcurementContractManagementExpenditureContractsTab';
import ProcurementContractManagementRevenueContractsTab from './procurement-contract-management-tab/ProcurementContractManagementRevenueContractsTab';
import ProcurementContractManagementSuppliersTab from './procurement-contract-management-tab/ProcurementContractManagementSuppliersTab';
import ProcurementContractManagementWorkforceContractsTab from './procurement-contract-management-tab/ProcurementContractManagementWorkforceContractsTab';
import { CONTRACT_MANAGEMENT_TABS, initialTabId } from './procurementTabs';

import Tabs, { RenderStrategyOnFirstVisit } from 'CommonComponents/Tabs';

import { useCustomEvent } from 'Hooks/useGlobalDOMEvents';

const ProcurementContractManagementTab = () => {
    const { settings } = useProcurement();

    const tabs = [
        {
            id: CONTRACT_MANAGEMENT_TABS.DASHBOARD,
            title: $t('Dashboard'),
            content: () => <ProcurementContractManagementDashboardTab />,
        },
        {
            id: CONTRACT_MANAGEMENT_TABS.SUPPLIERS,
            title: $t('Suppliers'),
            content: () => <ProcurementContractManagementSuppliersTab />,
        },
        {
            id: CONTRACT_MANAGEMENT_TABS.EXPENDITURE_CONTRACTS,
            title: $t('Expenditure Contracts'),
            content: () => <ProcurementContractManagementExpenditureContractsTab />,
        },
        {
            id: CONTRACT_MANAGEMENT_TABS.WORKFORCE_CONTRACTS,
            title: $t('Workforce Contracts'),
            content: () => <ProcurementContractManagementWorkforceContractsTab />,
            hidden: !settings.isWorkforceModuleEnabled,
        },
        {
            id: CONTRACT_MANAGEMENT_TABS.REVENUE_CONTRACTS,
            title: $t('Revenue Contracts'),
            content: () => <ProcurementContractManagementRevenueContractsTab />,
        },
    ];

    const [activeTab, setActiveTab] = useState(() => initialTabId(tabs, settings.activeTabId, CONTRACT_MANAGEMENT_TABS.DASHBOARD));

    useCustomEvent({
        eventName: SWITCH_CONTRACT_MANAGEMENT_TAB_EVENT,
        onSignal: (event) => {
            const tabId = event?.detail?.tabId;
            if (tabId) {
                setActiveTab(tabId);
            }
        },
    });

    return <Tabs tabs={tabs} activeTab={activeTab} onTabActivate={setActiveTab} renderStrategy={RenderStrategyOnFirstVisit} />;
};

export default ProcurementContractManagementTab;
